<template>
  <div class="black--text px-3">
    <div class="mx-5">
      <v-row class="subtitle-2 grey--text my-2">Supplier Financials</v-row>
      <div v-if="supplier.supplier_type === 'HOTEL'">
        <v-row>
          <v-col>
            <PorterageField
              :value="metaconfig.supplier_meta?.porterage"
              :includeOptional="!!metaconfig.porterage"
              @input="setPorterage"
              @include-optional="setIncludePorterage"
            />
          </v-col>
          <v-col>
            <CommissionField :value="metaconfig.supplier_meta?.commission" @input="setCommission" />
          </v-col>
          <v-col>
            <TaxField :value="metaconfig.supplier_meta?.tax" @input="setTax" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <FOCField :supplierType="supplier.supplier_type" :value="metaconfig.supplier_meta?.foc" @input="setFOC" />
          </v-col>
          <v-col>
            <OccupancyField :value="metaconfig.supplier_meta?.occupancy" @input="setOccupancy" />
          </v-col>
          <v-col>
            <ResortFeeField :value="metaconfig.supplier_meta?.resort_fee" @input="setResortFee" />
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-row>
          <v-col>
            <CommissionField :value="metaconfig.supplier_meta?.commission" @input="setCommission" />
          </v-col>
          <v-col>
            <TaxField :value="metaconfig.supplier_meta?.tax" @input="setTax" />
          </v-col>
          <v-col>
            <FOCField :supplierType="supplier.supplier_type" :value="metaconfig.supplier_meta?.foc" @input="setFOC" />
          </v-col>
        </v-row>
      </div>
      <v-divider />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import PorterageField from "./_PorterageField";
import CommissionField from "./_CommissionField";
import TaxField from "./_TaxField";
import FOCField from "./_FOCField";
import OccupancyField from "./_OccupancyField";
import ResortFeeField from "./_ResortFeeField";

export default {
  components: {
    PorterageField,
    CommissionField,
    TaxField,
    FOCField,
    OccupancyField,
    ResortFeeField,
  },
  props: {
    supplier: Object,
    metaconfig: Object,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    setPorterage(v) {
      Vue.set(this.metaconfig, "supplier_meta", { ...(this.metaconfig.supplier_meta ?? {}), porterage: v });
    },
    setIncludePorterage(v) {
      if (v) {
        Vue.set(this.metaconfig, "porterage", true);
      } else {
        Vue.delete(this.metaconfig, "porterage");
      }
    },
    setCommission(v) {
      Vue.set(this.metaconfig, "supplier_meta", { ...(this.metaconfig.supplier_meta ?? {}), commission: v });
    },
    setTax(v) {
      Vue.set(this.metaconfig, "supplier_meta", { ...(this.metaconfig.supplier_meta ?? {}), tax: v });
    },
    setFOC(v) {
      Vue.set(this.metaconfig, "supplier_meta", { ...(this.metaconfig.supplier_meta ?? {}), foc: v });
    },
    setOccupancy(v) {
      Vue.set(this.metaconfig, "supplier_meta", { ...(this.metaconfig.supplier_meta ?? {}), occupancy: v });
    },
    setResortFee(v) {
      Vue.set(this.metaconfig, "supplier_meta", { ...(this.metaconfig.supplier_meta ?? {}), resort_fee: v });
    },
    buildSupplierMetaFromSupplier() {
      const meta = this.supplier.meta || {};
      const { porterage, commission, tax, foc, occupancy_rate, resort_fee } = meta;

      return {
        ...(tax && { tax }),
        ...(porterage && {
          porterage:
            porterage.value === "not offered"
              ? { mode: porterage.value }
              : { mode: porterage.text, value: porterage.value },
        }),
        ...(commission && {
          commission: commission.value === "no" ? { enabled: false } : { enabled: true, value: commission.value },
        }),
        ...(foc && {
          foc: foc.value === "no" ? { mode: foc.value } : { mode: foc.method, value: foc.value, per: foc.per },
        }),
        ...(occupancy_rate && {
          occupancy: { value: occupancy_rate.value, cur: occupancy_rate.cur },
        }),
        ...(resort_fee && {
          resort_fee: { value: resort_fee.value, cur: resort_fee.cur },
        }),
      };
    },
    migrateLegacyOverrides(supplier_meta) {
      const next = { ...supplier_meta };

      // Legacy Extra Options used has_custom_* keys; fold them into supplier_meta.
      if (this.metaconfig.has_custom_commission && next.commission == null) {
        const value = this.metaconfig.custom_commission_value;
        next.commission =
          value === "no" || value === false || value == null
            ? { enabled: false }
            : { enabled: true, value };
      }

      if (
        this.metaconfig.has_custom_resortfee &&
        this.metaconfig.custom_resortfee_value?.value != null &&
        next.resort_fee == null
      ) {
        next.resort_fee = { ...this.metaconfig.custom_resortfee_value };
      }

      return next;
    },
  },
  mounted() {
    let supplier_meta = this.metaconfig.supplier_meta
      ? { ...this.metaconfig.supplier_meta }
      : this.buildSupplierMetaFromSupplier();

    supplier_meta = this.migrateLegacyOverrides(supplier_meta);

    this.$set(this.metaconfig, "supplier_meta", supplier_meta);

    // Mandatory porterage is always included in pricing.
    if (supplier_meta.porterage?.mode === "mandatory" && !this.metaconfig.porterage) {
      this.$set(this.metaconfig, "porterage", true);
    }
  },
};
</script>
